import { useUserStore } from '@/src/common/store/useUserStore'
import { PlatformBraze } from '@/src/services/Braze/PlatformBraze'
import { Platform } from 'react-native'

// eslint-disable-next-line @typescript-eslint/no-deprecated
useUserStore.subscribe(
  (state) => state.userInformation?.id,
  function keepBrazeUserInSyncWithMesaUser(userId) {
    if (userId) {
      PlatformBraze.changeUser(userId)
      Platform.OS === 'web' && void import('@braze/web-sdk').then((braze) => braze.openSession())
    }
  },
)
